<template>
  <div class="flex-auto overflow-y-auto no-scrollbar">
    <slot></slot>
  </div>
</template>

<script>
export default {};
</script>

<style>
</style>